module.exports = __webpack_public_path__ + "img/social-ln.d65f2124.svg";